module.exports = __webpack_public_path__ + "static/butchs-logo-0130114011ff462ce86cfa096cd44c19.png";